export async function initializeMobileApproval() {
  const root = document.querySelector('[data-mobile-approval]');
  if (!root) return;
  const status = root.querySelector('[data-mobile-approval-status]');
  const waitingMessage = status.textContent;

  async function poll() {
    try {
      const response = await fetch(root.dataset.mobileApprovalStatusUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        window.location.replace(root.dataset.mobileApprovalMethodsUrl);
        return;
      }

      const approval = (await response.json()).mobile_approval;
      if (approval?.status === 'approved') {
        window.location.replace(root.dataset.mobileApprovalContinueTo);
      } else if (approval?.status === 'pending') {
        status.textContent = waitingMessage;
        window.setTimeout(poll, 2000);
      } else if (['denied', 'expired'].includes(approval?.status)) {
        window.location.replace(root.dataset.mobileApprovalSignInUrl);
      } else {
        window.location.replace(root.dataset.mobileApprovalMethodsUrl);
      }
    } catch {
      status.textContent = root.dataset.mobileApprovalRetryMessage;
      window.setTimeout(poll, 3000);
    }
  }

  return poll();
}

document.addEventListener('DOMContentLoaded', initializeMobileApproval);
